import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '@aprova-digital/design-system';

import { IconComponent } from '../icon/icon.component';

export type ValidationErrorType = 'cpf' | 'cnpj' | 'email' | 'both_exists' | 'cnpj_email_exists' | 'generic';

export interface ValidationErrorData {
  type: ValidationErrorType;
  message?: string;
}

@Component({
  selector: 'aprova-validation-error-modal',
  standalone: true,
  imports: [CommonModule, ButtonComponent, IconComponent],
  templateUrl: './validation-error-modal.component.html',
  styleUrls: ['./validation-error-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ValidationErrorModalComponent {
  @Input()
  public isOpen: boolean = false;

  @Input()
  public errorData: ValidationErrorData = { type: 'generic' };

  @Output()
  public onClose = new EventEmitter<void>();

  @Output()
  public onRetry = new EventEmitter<void>();

  get title(): string {
    return 'Não foi possível criar a conta';
  }

  get message(): string {
    switch (this.errorData.type) {
      case 'cpf':
        return `Este CPF já está atrelado a uma conta externa. Caso precise de ajuda, entre em contato conosco através do suporte.`;
      case 'cnpj':
        return `Este CNPJ já está atrelado a uma conta externa. Caso precise de ajuda, entre em contato conosco através do suporte.`;
      case 'email':
        return `E-mail informado já está atrelado a uma conta externa. Caso precise de ajuda, entre em contato conosco através do suporte.`;
      case 'both_exists':
        return `O CPF e o E-mail informados já estão atrelados a uma conta externa. Caso precise de ajuda, entre em contato conosco através do suporte.`;
      case 'cnpj_email_exists':
        return `O CNPJ e o E-mail informados já estão atrelados a uma conta externa. Caso precise de ajuda, entre em contato conosco através do suporte.`;
      default:
        return this.errorData.message || 'Ocorreu um erro ao criar a conta. Por favor, tente novamente.';
    }
  }

  handleClose(): void {
    this.onClose.emit();
  }

  handleRetry(): void {
    this.onRetry.emit();
  }
}
